export default __webpack_public_path__ + "static/U.A-51a12633731c9bbee18a3e6616728e5c.png";